import React from 'react'
import { Box, Loading, Modal } from '@maui/elements'
import { ServiceDetails } from '../details/ServiceDetails'
import { useEodCaseById } from '@nautilusjs/mati-apis'

function ServiceDetailsModal({ ...modalProps }) {
  const { id } = modalProps
  const { data, error, isLoading } = useEodCaseById(id)
  return (
    <Modal {...modalProps} size="medium" ariaHideApp={false}>
      <Modal.Header onClose={modalProps.onClose}>
        <Modal.TitleIcon name="messages" />
        <Modal.Title>Ask An Expert | Service Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {data && <ServiceDetails data={data} />}
        {!error && isLoading && (
          <Box display="flex" alignItems="center" justifyContent="center">
            <Loading />
          </Box>
        )}
        {error && (
          <Box height={250}>
            Error fetching case
          </Box>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ServiceDetailsModal
